

document.addEventListener("DOMContentLoaded", function () {

    
  setTimeout(function () {


(function () {
  const CLASS_WRAP = 'cbb-slider-wrap';
  const CLASS_BAR  = 'cbb-scrollbar';
  const CLASS_THMB = 'cbb-scrollbar-thumb';
  const INIT_ATTR  = 'data-custom-scrollbar';

  // Inject CSS once
  if (!document.getElementById('cbb-scrollbar-style')) {
    const css = `
.${CLASS_WRAP}{position:relative}
.${CLASS_WRAP} .cbb-also-bought-slider{
  /* hide native bars cross-browser */
  scrollbar-width: none;          /* Firefox */
  -ms-overflow-style: none;       /* IE/Edge legacy */
}
.${CLASS_WRAP} .cbb-also-bought-slider::-webkit-scrollbar{display:none} /* Chrome/Safari */

.${CLASS_BAR}{
  position:absolute; left:0; right:0; bottom:0;
  height:2px; background:#bfbfbf; pointer-events:auto;
}
.${CLASS_THMB}{
  position:absolute; left:0; top:0; bottom:0;
  width:0; background:#2a2b2a; border-radius:2px;
  cursor:grab;
}
.${CLASS_THMB}.dragging{ cursor:grabbing }
`;
    const style = document.createElement('style');
    style.id = 'cbb-scrollbar-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function initOne(slider){
    if (!slider || slider.getAttribute(INIT_ATTR) === '1') return;
    // Create wrapper and bar
    const wrap = document.createElement('div');
    wrap.className = CLASS_WRAP;
    slider.parentNode.insertBefore(wrap, slider);
    wrap.appendChild(slider);

    const bar  = document.createElement('div');
    const thmb = document.createElement('div');
    bar.className  = CLASS_BAR;
    thmb.className = CLASS_THMB;
    bar.appendChild(thmb);
    wrap.appendChild(bar);

    slider.setAttribute(INIT_ATTR, '1');

    // Sync thumb with scroll
    function sync(){
      const sw = slider.scrollWidth;
      const vw = slider.clientWidth;
      const maxScroll = Math.max(sw - vw, 1);
      const ratio = slider.scrollLeft / maxScroll;
      const thumbPct = Math.max((vw / sw) * 100, 5); // min width so it's grabbable
      thmb.style.width = thumbPct + '%';
      thmb.style.left  = `calc(${ratio * (100 - thumbPct)}%)`;
      // Hide bar if no overflow
      bar.style.display = sw > vw ? 'block' : 'none';
    }

    // Drag to scroll
    let dragging = false, startX = 0, startLeftPct = 0, thumbPctCache = 0;

    function onDown(e){
      dragging = true;
      thmb.classList.add('dragging');
      const rect = bar.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      const leftPct = (parseFloat(thmb.style.left) || 0);
      startX = x; startLeftPct = leftPct;
      thumbPctCache = (parseFloat(thmb.style.width) || 0);
      e.preventDefault();
    }
    function onMove(e){
      if (!dragging) return;
      const rect = bar.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      const deltaPx = x - startX;
      const deltaPct = (deltaPx / rect.width) * 100;
      let newLeftPct = Math.min(100 - thumbPctCache, Math.max(0, startLeftPct + deltaPct));
      thmb.style.left = newLeftPct + '%';
      // update slider scroll from thumb
      const sw = slider.scrollWidth, vw = slider.clientWidth;
      const maxScroll = Math.max(sw - vw, 1);
      const ratio = newLeftPct / (100 - thumbPctCache || 1);
      slider.scrollLeft = ratio * maxScroll;
      e.preventDefault();
    }
    function onUp(){
      dragging = false;
      thmb.classList.remove('dragging');
    }

    thmb.addEventListener('mousedown', onDown);
    thmb.addEventListener('touchstart', onDown, {passive:false});
    window.addEventListener('mousemove', onMove, {passive:false});
    window.addEventListener('touchmove', onMove, {passive:false});
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchend', onUp);

    // Click-to-jump on the track
    bar.addEventListener('mousedown', (e)=>{
      if (e.target === thmb) return;
      const rect = bar.getBoundingClientRect();
      const clickRatio = (e.clientX - rect.left) / rect.width;
      const sw = slider.scrollWidth, vw = slider.clientWidth;
      slider.scrollLeft = clickRatio * (sw - vw);
    });

    slider.addEventListener('scroll', sync);
    window.addEventListener('resize', sync);
    // Initial sync after layout
    requestAnimationFrame(sync);
  }

  // Init all current sliders
  document.querySelectorAll('.cbb-also-bought-slider').forEach(initOne);

  // In case your slider is injected later:
  const obs = new MutationObserver(() => {
    document.querySelectorAll('.cbb-also-bought-slider').forEach(initOne);
  });
  obs.observe(document.documentElement, {childList:true, subtree:true});
})();




    const slider = document.querySelector('.cbb-also-bought-slider');
    if (!slider) return;

    // Optional UX tweaks
    slider.style.cursor = 'grab';
    slider.style.scrollBehavior = 'auto'; // avoid smooth-scroll fighting inertia

    let isDown = false;
    let startX, startScrollLeft;
    let lastX, lastT;
    let velocity = 0; // px/ms
    let rafId = null;

    function stopMomentum() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    }

    function momentumScroll(v0) {
      stopMomentum();
      let v = v0; // px/ms
      const decayPer16ms = 0.94; // friction (lower = more friction)
      let prevTs = 0;

      function step(ts) {
        if (!prevTs) prevTs = ts;
        const dt = ts - prevTs;      // ms since last frame
        prevTs = ts;

        // Apply velocity
        slider.scrollLeft -= v * dt;

        // Exponential decay relative to frame time
        const decay = Math.pow(decayPer16ms, dt / 16.67);
        v *= decay;

        // Stop when slow enough
        if (Math.abs(v) < 0.02) {
          stopMomentum();
          return;
        }
        rafId = requestAnimationFrame(step);
      }
      rafId = requestAnimationFrame(step);
    }

    // ---- Mouse
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      slider.style.cursor = 'grabbing';
      stopMomentum();
      startX = e.pageX;
      startScrollLeft = slider.scrollLeft;
      lastX = e.pageX;
      lastT = performance.now();
      e.preventDefault();
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const now = performance.now();
      const dx = e.pageX - lastX;
      const dt = now - lastT || 1;
      velocity = dx / dt; // px per ms (positive when moving right)

      const walk = (e.pageX - startX);
      slider.scrollLeft = startScrollLeft - walk;

      lastX = e.pageX;
      lastT = now;
    });

    document.addEventListener('mouseup', () => {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('active');
      slider.style.cursor = 'grab';
      // Multiply velocity for a snappier release
      momentumScroll(velocity * 2);
    });

    // ---- Touch (mobile)
    slider.addEventListener('touchstart', (e) => {
      if (!e.touches.length) return;
      isDown = true;
      stopMomentum();
      const t = e.touches[0];
      startX = t.pageX;
      startScrollLeft = slider.scrollLeft;
      lastX = t.pageX;
      lastT = performance.now();
    }, { passive: true });

    slider.addEventListener('touchmove', (e) => {
      if (!isDown || !e.touches.length) return;
      const t = e.touches[0];
      const now = performance.now();
      const dx = t.pageX - lastX;
      const dt = now - lastT || 1;
      velocity = dx / dt;
      const walk = (t.pageX - startX);
      slider.scrollLeft = startScrollLeft - walk;
      lastX = t.pageX;
      lastT = now;
    }, { passive: true });

    slider.addEventListener('touchend', () => {
      if (!isDown) return;
      isDown = false;
      momentumScroll(velocity * 2);
    });

    // Prevent accidental clicks when dragging far
    let moved = false;
    slider.addEventListener('mousedown', () => { moved = false; });
    slider.addEventListener('mousemove', () => { if (isDown) moved = true; });
    slider.addEventListener('click', (e) => {
      if (moved) e.preventDefault();
    }, true);
  }, 1000); // 1s delay
  /* CN image alt text 2026-10-29 */ (function(){var m={'35c7f6e8-2d38-41c9-9026-cee60c59c968':'Kara Technologies logo','28055ee3-1ac8-4ed6-a5fd-a99a662d5d4f':'Listen Technologies logo','27418d3d-4c6c-42fc-9ea2-d0a147bb0532':'Open training room with rows of tables and three cart-mounted displays','a249bf79-f258-4417-9f81-507048a14b66':'Dimly lit bar and restaurant interior','3f5c1ed4-a341-4a05-b0b4-1af0746e9614':'Boardroom with a long conference table and a wall-mounted display','c9e4d17d-6a65-4c04-a5e3-c860a5a7b1eb':'Large executive boardroom with a long table, leather chairs and a display on the far wall','c471ba5d-0a0f-4f1c-b6a2-61d43ce92106':'Wood-paneled boardroom with an oval table, white chairs and dual displays','049183bb-24ac-49e4-99ed-7d82881a66e3':'Hybrid meeting with colleagues at a conference table and remote participants on a wall display'};document.querySelectorAll('img:not([alt])').forEach(function(i){var s=(i.getAttribute('src')||'')+(i.getAttribute('srcset')||'');for(var k in m){if(s.indexOf(k)>-1){i.setAttribute('alt',m[k]);break;}}});})();
});


